import React from 'react';
import AssistantWorkspace from '../components/assistant/AssistantWorkspace';
import { assistantTestApi } from '../services/assistantTest';

export default function AsistenteTest() {
  return (
    <div>
      <AssistantWorkspace
        standalone
        apiClient={assistantTestApi}
        chatEndpoint="/assistant/test/chat"
      />
    </div>
  );
}
